// extracted by mini-css-extract-plugin
export default {"info":"styles_info__NIB+v","data":"styles_data__96xpT","gasIcon":"styles_gasIcon__G2Cn5"};